import type { ToastOptions as ReactToastOptions } from 'react-toastify';

// Constants
export const DEFAULT_AUTO_CLOSE_DURATION = 4000; // 4 seconds

export const defaultToastOptions: ReactToastOptions = {
  position: 'top-right',
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'light',
};

export type ToastOptions =
  | string
  | {
      message: string;
      title?: string;
      autoClose?: number | false;
      hideProgressBar?: boolean;
      closeOnClick?: boolean;
      pauseOnHover?: boolean;
      position?:
        | 'top-right'
        | 'top-center'
        | 'top-left'
        | 'bottom-right'
        | 'bottom-center'
        | 'bottom-left';
    };

export const getToastOptions = (
  options: ToastOptions,
  defaultAutoClose: number | false
): ReactToastOptions => {
  if (typeof options === 'string') {
    return { ...defaultToastOptions, autoClose: defaultAutoClose };
  }

  const { title: _title, message: _message, ...userOptions } = options;

  return {
    ...defaultToastOptions,
    ...userOptions,
    autoClose: options.autoClose ?? defaultAutoClose,
  };
};
